import { type ReactNode } from 'react';

import { components, type OptionProps } from 'react-select';
import cx from 'classnames';

import { color, Icon } from '@wf/components';

import styles from './Option.module.scss';

export type Props<T> = OptionProps<T> & {
  getOptionTagLabel?: (data: T) => ReactNode | undefined;
};

export type TOptionWithTwoDescriptions = {
  value: string;
  label: string;
  name: string;
  name2: string;
} | null;

function OptionWithTwoDescriptions({
  className,
  data,
  children,
  getOptionTagLabel,
  isSelected,
  ...rest
}: Props<TOptionWithTwoDescriptions>) {
  const { label, name, name2 } = data || {};

  return (
    <components.Option data={data} {...rest} isSelected={isSelected}>
      <div className={styles.content}>
        <div className={styles.titleRow}>
          <div
            className={cx(styles.title, {
              [styles.isSelected as string]: isSelected,
            })}
          >
            {label}
          </div>
          <div className={styles.descriptionContainer}>
            {name && <div className={styles.description}>{name}</div>}
            {name2 && <div className={styles.description}>{name2}</div>}
          </div>
        </div>
        {isSelected && <Icon name="ic_check" color={color('primary')} />}
      </div>
    </components.Option>
  );
}

export default OptionWithTwoDescriptions;
